angular.module('rjmNg.api').factory("EventNumberDefinition", [
  'BaseDefinition'
  (BaseDefinition) ->

    class EventNumberDefinition extends BaseDefinition

      @definition: 'sequence'
      @category: 'sameTable'
      @arg: 'column'
      @subtypes: [
          symbol: 'EVENT_NUMBER'
          description: 'The sequential count of times an event has occurred'
          typeFilter: []
      ]
      @filtersSupported: true

      @fromColumn: (structure, column) ->
        field = super structure, column, @definition

        field.properties = {}

        columnId = column.properties.owner_column_id
        tableId = structure.columns[columnId].table_id

        field.properties.owner_column =
          column: column.properties.owner_column_id
          table: tableId
        field.properties.timestamp_column =
          column: column.properties.timestamp_column_id
          table: tableId

        return field

      @toColumn: (structure, table, field) ->
        result = super structure, table, field
        result.field_type =  'value_general'
        angular.extend(result.properties,
          derivative_type: 'sequence'
          owner_column_id: field.properties.owner_column.column
          timestamp_column_id: field.properties.timestamp_column.column
        )

        return result

      @getSupportedRestrictionTableIds = (localTableId, field) ->
        if field.attrs?.ref?.table?
          [field.attrs.ref.table]
        else
          []

      @getFilterSetProperties: (localTableId, field) ->
        properties =
          tableIds: @getSupportedRestrictionTableIds(localTableId, field)

        if properties.tableIds.length is 0
          properties.warning =
            title: "Filters for this column type depend on the operation column"
            message: "Select an operation table to add filters and view filter sets."

        return properties

      @validateField: (column) ->
        super?.validateField(column)
        unless column.properties.timestamp_column.column? \
          and column.properties.timestamp_column.column isnt 0 \
          and column.properties.owner_column.column? \
          and column.properties.owner_column.column isnt 0
            throw "You need to select both timestamp and owner columns."
  ]
)
